module.exports = __webpack_public_path__ + "files/caca03f4c7b6ed30070d3998d78a9591.png";